





















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IActivity, IMineRankInfo, IPageParams, IRank } from "@/types";
import { getDistributionRank } from "@/api";

@Component
export default class Leaderboard extends Vue {
  @Prop({ type: Number, required: true })
  distributionId!: number;
  $refs!: {
    scroll: HTMLElement;
    scrollContent: HTMLElement;
  };

  rankList: Array<any> = [];
  isCaizhiActivity = false;

  @Watch("distributionId", { immediate: true })
  async getRank() {
    try {
      const { rows } = await getDistributionRank(this.distributionId);
      this.rankList = rows || [];
    } catch (error) {
      console.error(error);
    }
  }

  toMy() {
    this.$router.push({
      name: "my",
      params: { actId: String(this.distributionId) }
    });
  }
}
